<template>
	<div>
		<!-- Title -->
		<CCol md="12" class="mb-4">
			<CRow align-horizontal="end">
				<router-link
					:to="{ name: 'StaticLandingPageCreate' }"
					class="link-button"
				>
					<CButton class="btn-new-user transparent ml-3" color="secondary">
						<CIcon class="icon-left" name="cil-plus" />
						Create Static Landing Page
					</CButton>
				</router-link>
			</CRow>
		</CCol>

		<!-- Filter -->
		<CRow>
			<CCol class="d-flex align-items-start">
				<form
					class="search-form flex-fill"
					@submit.prevent="handleSearch"
				>
					<CInput
						v-model.trim="queryParams.q"
						type="text"
						placeholder="Search by name"
					>
						<template #prepend-content>
							<button class="btn-search" type="submit">
								<FontAwesomeIcon :icon="['far', 'search']" />
							</button>
						</template>
					</CInput>
				</form>
				<BaseFilterButton
					:is-open="isShowFilter"
					:has-filter="hasFilter"
					class="ml-3"
					data-id="filter-button"
					@onClick="toggleFilter"
				/>
			</CCol>
		</CRow>

		<!-- Filter Content -->
		<CRow>
			<CCol>
				<transition name="fade">
					<div
						v-if="isShowFilter"
						class="bg-gray-100 rounded-sm pt-3 px-3 mb-3"
						data-id="show-filter-box"
					>
						<CRow>
							<CCol md="3">
								<BaseDropDown
									v-model="status"
									:options="STATIC_LANDING_PAGE_STATUS_OPTIONS"
									:allow-empty="false"
									:searchable="false"
									label="name"
									label-drop-down="Status"
									track-by="value"
									class="select-custom"
									@input="handleSearch"
								/>
							</CCol>
						</CRow>
					</div>
				</transition>
			</CCol>
		</CRow>
		<CRow>
			<CCol class="mb-4">
				<BaseSearchFormFooter
					:count="list.meta.total"
					append-text="lists found"
					@onReset="handleResetFilter"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol>
				<BaseTable
					:is-loading="isLoading"
					:pagination="{
						pages: pagination.lastPage,
						activePage: pagination.currentPage
					}"
					:fields="STATIC_LANDING_PAGE_TABLE_FIELDS"
					:items="staticLandingPageList"
					striped
					hover
					fixed
					clickable-rows
					link-to="StaticLandingPageEdit"
					class="table-custom table-custom-link"
					@onPaginationClick="handlePageChange"
				>
					<template #no-items-view>
						<div class="empty-table-element">
							<p class="subtitle">
								{{ $t("global.searchNotFound", { field: "Static Landing Page" }) }}
							</p>
						</div>
					</template>
					<template #isActive="{item}">
						<CBadge
							class="badge-status"
							:color="getStatus(item).class"
						>
							{{ getStatus(item).title }}
						</CBadge>
					</template>
					<template #action="{item}">
						<!-- TODO: implement duplicate -->
						<CLink
							variant="ghost"
							color="secondary"
							:to="{ name: 'StaticLandingPageCreate', query: { source_id: item } }"
						>
							Duplicate
						</CLink>
					</template>
				</BaseTable>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import {
	cleanObject,
	hasSearchFilter,
} from '../assets/js/helpers';
import {
	STATIC_LANDING_PAGE_STATUS_OPTIONS,
	STATIC_LANDING_PAGE_TABLE_FIELDS,
	STATIC_LANDING_PAGE_STATUSES,
} from '../enums/staticLandingPage';

export default {
	name: 'StaticLandingPage',
	data() {
		return {
			STATIC_LANDING_PAGE_STATUS_OPTIONS,
			STATIC_LANDING_PAGE_TABLE_FIELDS,
			STATIC_LANDING_PAGE_STATUSES,
			isShowFilter: false,
			queryParams: {
				q: this.$route.query.q || null,
				is_active: (Number(this.$route.query.is_active) === 0 || Number(this.$route.query.is_active) === 1)
					? Number(this.$route.query.is_active)
					: null,
				page: Number(this.$route.query.page) || null,
			},
		};
	},
	computed: {
		...mapState('staticLandingPage', {
			list: 'list',
		}),
		...mapGetters({
			staticLandingPageList: 'staticLandingPage/staticLandingPageList',
		}),
		isLoading() {
			return this.list.isLoading;
		},
		pagination() {
			return this.list.meta;
		},
		hasFilter() {
			return hasSearchFilter(this.queryParams);
		},
		status: {
			get() {
				return this.STATIC_LANDING_PAGE_STATUS_OPTIONS.find((option) => option.value === this.queryParams.is_active);
			},
			set(status) {
				this.queryParams.is_active = status.value;
				this.updateUrlParams();
			},
		},
	},
	created() {
		this.isShowFilter = this.hasFilter;
		this.getStaticLandingPages(this.queryParams);
	},
	methods: {
		...mapActions({
			getStaticLandingPages: 'staticLandingPage/getStaticLandingPages',
		}),
		toggleFilter() {
			this.isShowFilter = !this.isShowFilter;
		},
		updateUrlParams() {
			const query = cleanObject(JSON.parse(JSON.stringify(this.queryParams)));
			this.$router.push({ query }).catch(() => {});
			this.getStaticLandingPages(query);
		},
		handlePageChange(page) {
			this.queryParams.page = page;
			this.updateUrlParams();
		},
		handleSearch() {
			this.queryParams.page = null;
			this.updateUrlParams();
		},
		handleResetFilter() {
			this.queryParams = {
				q: null,
				is_active: null,
				page: null,
			};

			this.updateUrlParams();
		},
		getStatus(isActive) {
			return this.STATIC_LANDING_PAGE_STATUSES[isActive ? 1 : 0];
		},
	},
};
</script>

<style lang="scss" scoped>
.btn-search {
	background: transparent;
	box-shadow: none;
	border: none;
	padding: 0;
}
</style>
